import React from 'react';
import {
  Box,
  VStack,
  Heading,
  Text,
  useBreakpointValue,
  Icon,
  Flex
} from '@chakra-ui/react';

// Desktop monitor icon component
const DesktopIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"/>
  </svg>
);

const DesktopOnlyWrapper = ({ children }) => {
  // Detect if user is on mobile/tablet (anything smaller than lg breakpoint)
  const isMobile = useBreakpointValue({ base: true, lg: false });

  // If user is on desktop, render the children normally
  if (!isMobile) {
    return children;
  }

  // If user is on mobile, show the desktop-only message
  return (
    <Box
      minH="100vh"
      bg="#0a0a0a"
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={6}
    >
      <Box maxW="md" w="100%" textAlign="center">
        <VStack spacing={8}>
          {/* Desktop Icon */}
          <Flex
            w="120px"
            h="120px"
            borderRadius="full"
            bg="rgba(255,255,255,0.04)"
            border="1px solid rgba(255,255,255,0.10)"
            align="center"
            justify="center"
          >
            <Icon as={DesktopIcon} w="52px" h="52px" color="rgba(255,255,255,0.35)" />
          </Flex>

          {/* Main Message */}
          <VStack spacing={3}>
            <Heading
              size="lg"
              color="#fafafa"
              fontWeight="700"
              letterSpacing="-0.02em"
              textAlign="center"
            >
            Larger screens required
            </Heading>
            <Text fontSize="sm" color="#a3a3a3" lineHeight="1.8" textAlign="center">
            Please use a larger screen to access this application.
            </Text>
          </VStack>
        </VStack>
      </Box>
    </Box>
  );
};

export default DesktopOnlyWrapper;
